import { client } from '@/apollo/vue-apollo';
import axios from 'axios';
import { gql } from 'graphql-tag';

/**
 * Bulk insert into message_recipient
 * @param {string} participant
 * @param {string} legal_entity
 * @param {array} messages
 * @param {string} recipient
 */
export function messageLinkRecipient(
	participant: string,
	legalEntity: string | null,
	messages: string[],
	recipients: string[]
) {
	const payload = {
		participant: participant,
		legalEntity: legalEntity,
		messages: messages,
		recipients: recipients
	};
	return axios.post(`https://${process.env.VUE_APP_API_ENDPOINT}/mailbox/message/link-recipient`, payload, {
		headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
	});
}

/**
 * Bulk delete from message_recipient
 */
export function messageUnlinkRecipient(
	participant: string,
	legalEntity: string | null,
	messages: string[],
	recipients: string[]
) {
	const payload = {
		participant: participant,
		legal_entity: legalEntity,
		messages: messages,
		recipients: recipients
	};

	return axios.post(`https://${process.env.VUE_APP_API_ENDPOINT}/mailbox/message/unlink-recipient`, payload, {
		headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
	});
}

/**
 * Archive a message
 * @param {string} participant
 * @param {string} message
 */
export function messageArchive(
	person: string,
	participant: string,
	messages: string[]
) {
	const payload = {
		person: person,
		participant: participant,
		messages: messages
	};

	return axios.post(`https://${process.env.VUE_APP_API_ENDPOINT}/mailbox/message/archive`, payload, {
		headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
	});
}

/**
 * Unarchive a message
 * @param {string} participant
 * @param {string} message
 */
export function messageUnarchive(
	participant: string,
	messages: string[]
) {
	const payload = {
		participant: participant,
		messages: messages
	};

	return axios.post(`https://${process.env.VUE_APP_API_ENDPOINT}/mailbox/message/unarchive`, payload, {
		headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
	});
}

export function messageAssign(
	participant: string,
	messages: string[],
	assignee: string
) {
	const payload = {
		participant: participant,
		messages: messages,
		assignee: assignee
	};

	return axios.post(`https://${process.env.VUE_APP_API_ENDPOINT}/mailbox/message/assign`, payload, {
		headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
	});
}

export function messageUnassign(
	participant: string,
	message: string,
	assignee: string
) {
	const payload = {
		participant: participant,
		message: message,
		assignee: assignee
	};

	return axios.post(`https://${process.env.VUE_APP_API_ENDPOINT}/mailbox/message/unassign`, payload, {
		headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
	});
}

